import { render, staticRenderFns } from "./markkinointikielto.vue?vue&type=template&id=256be4ec&"
import script from "./markkinointikielto.vue?vue&type=script&lang=js&"
export * from "./markkinointikielto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports